import { Action, ThunkDispatch } from 'store/store';
import Services from 'store/Services';
import { showInfoAsync, showWarningAsync } from 'notification/store/thunks';
import State from 'store/State';

export const supportRequestAction =
    (
        enquiry: string,
        name?: string,
        screenshot?: string,
        forDevTeam?: boolean
    ) =>
    async (
        dispatch: ThunkDispatch<Action<unknown>>,
        getState: () => State,
        { contactSupportService }: Services
    ) => {
        const SUCCESS_MESSAGE = 'Your enquiry has been sent';
        const ERROR_MESSAGE = 'Unable to send enquiry. Please try again later';

        try {
            await contactSupportService.sendSupportRequest(
                enquiry,
                name,
                screenshot,
                forDevTeam
            );
            dispatch(showInfoAsync(SUCCESS_MESSAGE));
        } catch (err) {
            dispatch(showWarningAsync(ERROR_MESSAGE));
        }
    };
